import './RecorderBlock.scss';
import React, { useEffect, useMemo, useState } from 'react';
import { AgentCard, FormItem, Select } from '@components';
import { apiInstance, RecordingAgentReg } from '@api';
import { toast } from 'react-toastify';
import { Spinner } from '../../shared';

interface RecorderBlockProps {
	selectedAgent: RecordingAgentReg;
	onAgentChanged: (newAgent: RecordingAgentReg) => void;
}

function RecorderBlock(props: RecorderBlockProps): JSX.Element {
    const { 
		selectedAgent,
		onAgentChanged,
    } = props;

    const [agentsInfo, setAgentsInfo] = useState<RecordingAgentReg[]>([]);

    useEffect(() => {
		async function fetchAgents(): Promise<void> {
			try
			{
				const newAgentsInfo = await apiInstance.listRecorderRegistrations();
				setAgentsInfo(newAgentsInfo.recordingAgentRegs);
				if (!selectedAgent && newAgentsInfo && newAgentsInfo.recordingAgentRegs.length) {
					onAgentChanged(newAgentsInfo.recordingAgentRegs[0]);
				}
			}
			catch(ex)
			{
				toast.error(`${ex}`, {autoClose: false });
			}
		}

		fetchAgents();
	}, [onAgentChanged, selectedAgent]);

    const agentsView = useMemo(() => {
		return selectedAgent ?
			<FormItem label="Расположение">
				<Select<RecordingAgentReg>
					onChange={onAgentChanged}
					textName="name"
					value={selectedAgent}
					options={agentsInfo}
					className='agent_select'
				/>
				{selectedAgent ? 
					<AgentCard 
						onAgentChanged={onAgentChanged}
						agent={selectedAgent}
					/> : null}
			</FormItem>
		: <Spinner />;
	}, [agentsInfo, selectedAgent, onAgentChanged]);

    return agentsView;
}

export { RecorderBlock }